import React from 'react'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import DatePicker from '../../../form/component/DatePicker'
import { BACKEND_URL } from '../../../../util/api'
import { COMPANY_CODE_SUNSHINE_SMILE_GERMANY, COMPANY_CODE_SUNSHINE_SMILE_UK } from '../../../internationalization/const'
import moment from "moment";


class InvoiceCSV extends React.Component {
    constructor (props) {
        super(props)
        this.changeSelect = this.changeSelect.bind(this)

        this.maxDate = moment().subtract(1, 'days')

        this.state = {
            fromDate: this.maxDate.format('YYYY-MM-DD'),
            toDate: this.maxDate.format('YYYY-MM-DD'),
        }
    }

    changeSelect (name, value) {
        this.setState({
            ...this.state,
            [name]: value,
        })
    }

    render () {
        const downloadLinkInvoice = BACKEND_URL + '/api/invoice/generate-csv'
        const downloadLinkInvoiceForCompany = BACKEND_URL + '/api/invoice/generate-csv-for-company'
        const dates = '?fromDate=' + this.state.fromDate + '&toDate=' + this.state.toDate

        const downloadLinkInvoiceFromToDate = downloadLinkInvoice + dates
        const downloadLinkInvoiceDACH = downloadLinkInvoiceForCompany + dates + '&company_code=' + COMPANY_CODE_SUNSHINE_SMILE_GERMANY
        const downloadLinkInvoiceUK = downloadLinkInvoiceForCompany + dates + '&company_code=' + COMPANY_CODE_SUNSHINE_SMILE_UK

        return (
            <div>
                <ContentBox title="Search Criteria">
                    <Row>
                        <Column size={2}>
                            <LabelInput label="From">
                                <DatePicker
                                    object={this.state}
                                    name="fromDate"
                                    dateFormat="YYYY-MM-DD"
                                    maxDate={this.maxDate}
                                    minDate={null}
                                    placeholder="Choose from date"
                                    onChange={this.changeSelect}
                                    onBlur={() => {}}
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                />
                            </LabelInput>

                        </Column>
                        <Column size={2}>
                            <LabelInput label="To">
                                <DatePicker
                                    object={this.state}
                                    name="toDate"
                                    dateFormat="YYYY-MM-DD"
                                    maxDate={this.maxDate}
                                    minDate={null}
                                    placeholder="Choose to date"
                                    onChange={this.changeSelect}
                                    onBlur={() => {}}
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                    />
                            </LabelInput>
                        </Column>
                        <Column size={2} className="status-download-link-container">
                            <a href={downloadLinkInvoiceDACH} target="_blank" rel="noopener noreferrer">Download Invoice CSV (DACH+ES)</a>
                        </Column>
                        <Column size={2} className="status-download-link-container">
                            <a href={downloadLinkInvoiceUK} target="_blank" rel="noopener noreferrer">Download Invoice CSV (UK)</a>
                        </Column>
                        <Column size={4} className="status-download-link-container">
                            <a href={downloadLinkInvoiceFromToDate} target="_blank" rel="noopener noreferrer">Download Invoice Item CSV</a>
                        </Column>
                    </Row>
                </ContentBox>

            </div>
        )
    }
}

InvoiceCSV.propTypes = {}


export default withLayout(InvoiceCSV)



// WEBPACK FOOTER //
// ./src/modules/analytics/component/invoice-csv/InvoiceCSV.js